var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import Card from 'antd/lib/card';
import 'antd/lib/card/style/index.css';
import Row from 'antd/lib/grid/row';
import Col from 'antd/lib/grid/col';
import 'antd/lib/grid/style/index.css';
import Page from '../../templates/Page';
import DashboardForm from './DashboardForm';
import ScrollerAthleteScoreRoute from 'src/imports/components/ScrollerAthleteScoreRoute';
import Scoreboard from 'src/imports/components/Scoreboard/components';
var selfStyles = require('./styles.scss');
var PageDashboard = (function (_super) {
    __extends(PageDashboard, _super);
    function PageDashboard(props) {
        return _super.call(this, props) || this;
    }
    PageDashboard.prototype.render = function () {
        var event = this.props.workspaceEvent.event;
        return (React.createElement(Page, { documentTitle: "Dashboard | " + event.nameShort, pageTitle: 'Dashboard', isFixedScreenSize: true },
            React.createElement(Row, { gutter: 24 },
                React.createElement(Col, { xs: 24, md: 12, className: selfStyles.column },
                    React.createElement(Card, { className: selfStyles.scoreboardCard },
                        React.createElement(Scoreboard, { isPlatform: true }))),
                React.createElement(Col, { xs: 24, md: 12, className: selfStyles.column },
                    React.createElement(DashboardForm, null))),
            React.createElement(ScrollerAthleteScoreRoute, { isPlatform: true })));
    };
    return PageDashboard;
}(React.Component));
var mapStateToProps = function (state) { return ({
    workspaceEvent: {
        event: state.workspaceEvent.event && state.workspaceEvent.event.data[0],
    },
}); };
export default connect(mapStateToProps)(PageDashboard);



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/PageDashboard/index.tsx
// module id = 845
// module chunks = 0